import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../../HandleAPICalls/actions';
import { WarehouseComponent } from './component';
import { onChange_Createuser_Warehouse } from '../CreateUserComp/action';

const AddWarehouseContainer = (props) => {
    const [warehouseData, setWarehouseData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isRadioClicked, setIsRadioClicked] = useState(false);

    useEffect(() => {
        props.getDataFromAPI(
            '/partner/api/v2/warehouse/list',
            'GET',
            undefined,
            (response) => {
                setWarehouseData(response);
                setFilteredData(response); // Initialize filtered data
            },
            (err) => {
                toastr.error('Failed', 'Unable to fetch vending machine warehouse listing');
            }
        );
    }, []);

    const handleWarehouse = (e, id) => {
        setIsRadioClicked(true);
        props.onChange_Createuser_Warehouse(id);
    };

    const handleSearch = (query) => {
        const lowerCaseQuery = query.toLowerCase();
        const filtered = warehouseData.filter(
            (item) =>
                item.warehouseName.toLowerCase().includes(lowerCaseQuery) ||
                item.warehouseId.toString().includes(query)
        );
        setFilteredData(filtered);
    };

    return (
        <WarehouseComponent
            data={filteredData}
            handleWarehouse={handleWarehouse}
            handleSearch={handleSearch} // Pass the search handler
            isRadioClicked={isRadioClicked}
        />
    );
};

const mapStateToProps = ({ props }) => ({ props });

export default connect(mapStateToProps, {
    getDataFromAPI,
    onChange_Createuser_Warehouse,
})(AddWarehouseContainer);
